import { axiosApi } from '../axios';

const DEVELOPERS_URL = 'developers';

export default {
  accounts: {
    registerDeveloper(data) {
      return axiosApi.post(`/${DEVELOPERS_URL}/accounts`, data);
    },

    updateDeveloper(data) {
      return axiosApi.patch(`/${DEVELOPERS_URL}/account`, data);
    },

    updatePersonalData(token, data) {
      return axiosApi.put(`/${DEVELOPERS_URL}/accounts/${token}/personal_data`, data);
    },

    softSkills(token, answers) {
      return axiosApi.put(`/${DEVELOPERS_URL}/accounts/${token}/soft_skills`, answers);
    },

    developerSoftSkills(answers) {
      return axiosApi.patch(`/${DEVELOPERS_URL}/account/soft_skills`, answers);
    },

    validate(token) {
      return axiosApi.get(`/${DEVELOPERS_URL}/accounts/${token}/current_step`);
    },
  },

  survey: {
    index() {
      return axiosApi.get(`/${DEVELOPERS_URL}/survey`);
    },
  },
};
